import { render, staticRenderFns } from "./CouriersList.vue?vue&type=template&id=623fd8fa&scoped=true&"
import script from "./CouriersList.vue?vue&type=script&lang=js&"
export * from "./CouriersList.vue?vue&type=script&lang=js&"
import style0 from "./CouriersList.vue?vue&type=style&index=0&id=623fd8fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623fd8fa",
  null
  
)

export default component.exports